(function() {
  angular.module('cfn').factory('CompanySettings', CompanySettings);

  CompanySettings.$inject = ['$resource'];
  function CompanySettings($resource) {
    return $resource(
      '/365FarmNet/rest/settings/settings',
      {},
      {
        save: { method: 'PUT' }
      }
    );
  }
})();
